import {colors} from '@/constants'
import {createTheme} from '@mui/material'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxl: true
    extra: true
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#A3A3A3',
      contrastText: '#FFFFFF50',
    },
    info: {
      main: '#E3E3E3',
    },
    warning: {
      main: '#4041BB',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1128,
      xl: 1488,
      xxl: 1848,
      extra: 2208,
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif!important',
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: {variant: 'description'},
          style: {
            color: colors.gray,
            fontSize: '16px',
            fontWeight: 500,
          },
        },
        {
          props: {variant: 'h1'},
          style: {
            color: colors.white,
            fontSize: '40px',
            fontWeight: 600,
            lineHeight: '120%',
          },
        },
        {
          props: {variant: 'button'},
          style: {
            color: colors.white,
            fontSize: '24px',
            fontWeight: 600,
            lineHeight: '120%',
            textTransform: 'inherit',
          },
        },
        {
          props: {variant: 'body1'},
          style: {
            color: colors.white,
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '120%',
          },
        },
        {
          props: {variant: 'body2'},
          style: {
            color: colors.white,
            fontSize: '16px',
            fontWeight: 500,
          },
        },
        {
          props: {variant: 'link'},
          style: {
            color: colors.white,
            fontSize: '20px',
            fontWeight: 600,
            textDecoration: 'underline',
          },
        },
      ],
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
})

export default theme
